// Libs
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import React from "react";

// DLS
import "@collectivehealth/dls-panel";

// Components
import RenderIf from "components/RenderIf";

// Styles
import styles from "./ErrorPagePanel.css";

// Constants
import DATA_HOOKS from "./ErrorPagePanel.datahooks";

export default function ErrorPagePanel({ image, heading, body }) {
  const hasLongBodyText = body && typeof body === "string" && body.length >= 100;

  return (
    <dls-panel class={styles.root} data-hook={DATA_HOOKS.ROOT}>
      <header className={styles.header} slot="panel-head">
        <aside className={styles.image}>{image}</aside>
        <h1 className={styles.heading}>{heading}</h1>
      </header>

      <RenderIf test={!isEmpty(body)}>
        <section
          className={hasLongBodyText ? styles.bodyLong : styles.body}
          data-hook={DATA_HOOKS.BODY}
          slot="panel-body"
        >
          {body}
        </section>
      </RenderIf>
    </dls-panel>
  );
}

ErrorPagePanel.propTypes = {
  image: PropTypes.node,
  heading: PropTypes.node,
  body: PropTypes.node
};
